import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";
import AniLink from "gatsby-plugin-transition-link/AniLink"

const Blog = ({ page = false }) => {
  const data = useStaticQuery(graphql`
      query BlogPreviewQuery {
        allContentfulBlog(sort: {createdAt: ASC}) {
          nodes {
            title
            slug
            image {
              gatsbyImageData(width: 1080)
            }
          }
        }
      }
  `)

  const Image = ({ data }) => {
    if (!data?.image?.gatsbyImageData) {
      return <div>Picture not found</div>
    }

    return <GatsbyImage image={{ ...data?.image?.gatsbyImageData, aspectRatio: 10 / 11 }}  alt={''}/>;
  }

  const OfferItem = ({ data }) => {
    return (
      <AniLink fade to={`/blog/${data?.slug}`} className="offer-preview-item">
        <div className="offer-preview-image">
          <Image data={data} />
        </div>
        <div className="offer-preview-content">
          <h4>{data?.title}</h4>
          <p>{data?.shortDesc?.internal?.content}</p>
        </div>
      </AniLink>
    )
  }

  return (
    <div id="oferta">
      <div className="section offer-section">
        <div className="section-pre-content">
          <h2 className="section-title">
            Blog
            {/* {offerSectionData?.title} */}
          </h2>
          <p>
            {/* {offerSectionData?.text?.internal?.content} */}
          </p>
        </div>
        <div className="offer-preview-items">
          {page ? (
            <>
              {data?.allContentfulBlog?.nodes?.map((offerData) => <OfferItem key={offerData.slug} data={offerData} />)}
            </>
          ) : (
              <>
                {data?.allContentfulBlog?.nodes?.map((offerData, index) => {
                  if (index < 3) {
                    return <OfferItem key={offerData.slug} data={offerData} />
                  }
                })}
              </>
            )}
        </div>
        {!page && (
          <div className="button-container">
            <AniLink fade className="button" to="/blog">
              Więcej
            </AniLink>
          </div>
        )}
      </div>
    </div>
  )
}

Blog.propTypes = {
}

Blog.defaultProps = {
}

export default Blog
